import { Box, Typography } from "@mui/material";
import React from "react";
import ArrowDown from "../../../../Custom-imeges/ArrowDown";
import Skeleton from "../../../main-page/components/SettingPages/Help & Support/Skeleton";

interface SelectBtnProps {
  btnTitle: string;
  selectedItemName: string;
  selectedItemDesc: string;
  btnAction?: () => void;
  isLoading?: boolean;
}

export const SelectBtn = ({
  btnTitle,
  selectedItemName,
  selectedItemDesc,
  btnAction,
  isLoading,
}: SelectBtnProps) => {
  return (
    <Box className="select-btn-container">
      <Typography className="select-btn-title">{btnTitle}</Typography>
      <Box
        className="select-btn-box"
        onClick={isLoading ? undefined : btnAction}
      >
        <Box className="selected-item">
          {isLoading ? (
            <Skeleton
              width="160px"
              height="20px"
              margin="0"
              borderRadius="6px"
            />
          ) : (
            <Typography className="selected-item-name">
              {selectedItemName}
            </Typography>
          )}
          {isLoading ? (
            <Skeleton
              width="60px"
              height="12px"
              margin="0"
              borderRadius="6px"
            />
          ) : (
            <Typography className="selected-item-desc">
              {selectedItemDesc}
            </Typography>
          )}
        </Box>
        <ArrowDown className="custom-icon-stroke" />
      </Box>
    </Box>
  );
};
